import ListManagerComponent from './list-manager-component.js';

import Confirm from '../alerts/confirm.js';

import Api from '../api/api.js';

export default class ListManagerDeletor extends ListManagerComponent
{

	constructor(settings = {}) 
	{	
		super(settings)
	}

	bindEvents()
	{
		this.manager.$el('container').on('click', this.settings['btn'], this.onDeleteListItem.bind(this));
	}

	onDeleteListItem(e) 
	{
		e.preventDefault();
		const $target = $(e.target);
		const url = $target.data('url');
	    this.confirmDelete().then(() => {
	    	this.deleteItem(url);
	    });
	    return this;
	}

	confirmDelete() 
	{
		return (new Confirm).delete(
			'Are you sure?', 
			'Are you sure you want to permanently delete this record and all linked data!', 
			'Yes, delete it!'
		);
	}

	deleteItem(url) 
	{
		(new Api).deleteRequest(url, {}).then((response) => {

			Swal.fire({title:'Deleted successfully', text:response.msg, icon: "success"}).then(() => {
			
				window.location.reload();
			
			});
		
		});
	}


}
/*
	Swal.fire({
		title: response.error ? 'Error' : 'Success',
		text: response.msg,
		icon: response.error ? 'error' : 'success',
		showCancelButton: false,
	}).then(() => {
		window.location.reload();
	});
*/
